export enum EntityType {
  Records = 'records',
  Institutions = 'institutions',
  Funds = 'funds'
}
